/**
 * @ngdoc directive
 * @name promo Navbar
 * Add class to body when opened the main menu on mobile-view
 *
 *
 * @example
 <div promo-navbar="isNavVisible">
 */

(function() {
    'use strict';

    directive.$inject = ["SCREENSIZE"];
    app.directive('promoNavbar', directive);

    function directive(SCREENSIZE) {
        return {
            scope: {
                promoNavbar: '='
            },
            link: link
        };

        function link(scope) {
            var win = angular.element(window);
            var winWidth = win.innerWidth();
            var body = angular.element(document).find('body');
            var prevScrollTop;

            if (winWidth > SCREENSIZE.sm) return;

            scope.$watch('promoNavbar', function(n) {
                if (n) {
                    prevScrollTop = win.scrollTop();
                    body.addClass('js-opened-promo-navbar');
                } else {
                    body.removeClass('js-opened-promo-navbar');
                    win.scrollTop(prevScrollTop);
                }
            });
        }
    }

})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/promoNavbar.js